import {dataHooks} from '@wix/data-hooks'

export const searchAgainButtonDataHooks = dataHooks<{
  button: {}
}>('search-again-button')
